import React from 'react';
const links = ['Términos de Servicio', 'Política de Privacidad', 'Política de Reembolso', 'Contacto'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-93" data-mp="3ghc2o28413o8">
      <div className="mx-auto max-w-5xl text-center" data-id="element-94" data-mp="32onkf2vm5o8y">
        <p className="font-serif text-xl font-black uppercase tracking-tight text-stone-900" data-id="element-95" data-mp="32m1aiwl92wnk">
          INGLÉS LISTO™
        </p>
        <p className="mt-2 text-xs font-medium text-stone-500" data-id="element-96" data-mp="3ueilfwsu32dg">
          12 Volúmenes · 5 Bonos · Acceso de por Vida
        </p>
        <nav aria-label="Pie de página" data-id="element-97" data-mp="37fun6gwqy3r">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-stone-500" data-id="element-98" data-mp="36czunggsbik">
            {links.map(link => <li key={link} data-id="element-99" data-mp="3qbvojhhb2r9e">
                <a href="#offer" className="transition-colors duration-150 hover:text-red-600" data-id="element-100" data-mp="3qf9s2t1ph6if">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-stone-500" data-id="element-101" data-mp="3labq1ri0byo9">
          © 2026 INGLÉS LISTO™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}